import React, { Component } from "react";
import { Button, Card } from "react-bootstrap";
import { platform } from "../../Style";
import LoadPage from "../Load/LoadPage";
import { addReportAttachment } from "../../actions/OVVRequests";
import { withTranslation } from "react-i18next";
import { FilePond } from "react-filepond";
import fileUpload from "./../../images/file-upload.png";
import downloadIcon from "./../../images/download-icon.svg";
import DialogComponent from "../Project/Dialog";
import { config as serverUploadConfig } from "../../helpers/serverUpload";

export class OVVRequestForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestType: 1,
      valid: {
        fileDocument: true
      },
      modalSendDocuments: false,
      load: false,
      disabledSave: true,
      description: "",
      document: [],
      requestTypes: [],
    };
  }


  validInfo = () => {
    const { document } = this.state;
    let valid = false;
    if (document && document.length > 0) {
      this.setState({
        valid: {
          fileDocument: true,
        },
      });
      valid = true;
    } else {
      this.setState({
        valid: {
          fileDocument: false,
        },
      });
      valid = false;
    }
    return valid;
  };

  handleSubmit = () => {
    const { recharge, project } = this.props
    const { document } = this.state;
    let fileInformation = {};

    if (document && document.length > 0) {
      if (
        Object.keys(document[0].getMetadata()).length > 0 &&
        document[0].getMetadata().name
      ) {
        fileInformation = document[0].getMetadata();
      } else {
        fileInformation = JSON.parse(document[0].serverId);
      }
    }

    const data = {
      projectId: Number(project.id),
      document: Object.keys(fileInformation).length > 0 ? fileInformation : "",
    };
    this.setState({
      load: true,
    });

    addReportAttachment(data).then((response) => {
      if (response.status) {
        this.setState({
          load: false,
          document: [],
          modalSendDocuments: false
        });
        recharge();
      }
    });
  };

  showAttachView = (project) => {
    // If is validation or verification stage = show
    return project.process > 1 && (project.projectStageId === 2 &&
      project.isFormulated === 1 &&
      project.isValidated === 0 &&
      project.isRegistrated === 0 &&
      project.isVerified === 0) || (project.projectStageId === 3 &&
        project.isFormulated === 1 &&
        project.isValidated === 1 &&
        project.isVerified === 0);
  }


  render() {
    const { requests, t, token, project } = this.props;
    const { load, document, modalSendDocuments, valid, disabledSave } = this.state;
    return (
      <div className="p-0 m-0">
        {/* Send document modal */}
        <LoadPage load={load} />
        <DialogComponent
          t={t}
          view={modalSendDocuments}
          tittle={t("confirmation")}
          message={t("ovvRequests.confirmSendAttachedInfo")}
          buttons={[
            {
              value: `${t("buttons.cancel")}`,
              onclick: () => {
                this.setState({
                  modalSendDocuments: false,
                });
              },
            },
            {
              value: `${t("buttons.accept")}`,
              onclick: () => {
                this.handleSubmit()
              }
            },
          ]}
        />
        <Card>
          <Card.Body>
            {((token && token.typeAccount !== 'certifier') && (project && this.showAttachView(project))) &&
              <Card className="mb-4" style={{ position: "relative" }}>
                <Card.Header>{t("ovvRequests.uploadTemplate")}</Card.Header>
                <Card.Body>
                  <p>
                    {t("ovvRequests.uploadCompletedFindingsTemplate")}:
                  </p>
                  <div className="mt-2 mb-2" style={{ border: !valid.fileDocument ? "2px solid red" : "2px solid black" }}>

                    <FilePond
                      files={document}
                      allowMultiple={false}
                      server={serverUploadConfig("/api/file/upload", "projects")}
                      labelIdle={`<div style="display:flex, align-items:center">
                                                                              <img src="${fileUpload}" style="width: 3rem; height: 3rem; cursor: pointer;"/>
                                                                            </div>`}
                      acceptedFileTypes={[
                        "application/msword",
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                      ]}
                      onupdatefiles={(fileItems) =>
                        this.setState({
                          document: fileItems,
                          disabledSave: true,
                          valid: {
                            fileDocument: true,
                          }
                        })
                      }
                      onprocessfile={(error, file) => {
                        if (error) {
                          console.error('File processing error:', error);
                        } else {
                          this.setState({
                            disabledSave: false,
                          })
                        }
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      style={platform.buttonSuccess}
                      disabled={disabledSave}
                      onClick={() => {
                        if (this.validInfo()) {
                          this.setState({ modalSendDocuments: true })
                        }

                      }}
                    >
                      {t("buttons.send")}
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            }
            <Card className="mb-3">
              <Card.Header>{t("ovvRequests.report")}</Card.Header>
              <Card.Body>
                {requests && requests.length > 0 ? requests.map((request) => {
                  return (
                    <div
                      key={request.id}
                      style={{
                        display: "flex",
                        border: "3px solid black",
                        borderRadius: "12px",
                        height: "100px",
                        padding: "18px",
                        alignItems: "center",
                        marginBottom: "10px"
                      }}
                    >
                      <div style={{ width: "60%" }}>
                        <p style={{ margin: 0 }}>
                          <b>{request.document.name}</b>
                        </p>
                        <p style={{ margin: 0, fontSize: "small" }}>{t("ovvRequests.type")}: {request.document.requestType}</p>
                      </div>
                      <div style={{ width: "20%" }}>
                        <p style={{ margin: 0 }}>
                          <b>{t("ovvRequests.currentVersion")}</b>
                        </p>
                        <p style={{ margin: 0 }}>{request.document.date}</p>
                      </div>
                      <div style={{ width: "20%", display: "flex", justifyContent: "center" }}>
                        <img
                          src={downloadIcon}
                          onClick={() => { window.open(request.document.url, "_blank") }}
                          alt="Download"
                          style={{
                            cursor: "pointer",
                            width: "20px",
                            height: "20px",
                            marginLeft: "8px",
                          }}
                        />
                      </div>
                    </div>
                  )
                }) : (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <p>{t("ovvRequests.noReportsToShow")}</p>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default withTranslation()(OVVRequestForm);
